import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import CylinderDropdown from "../../../../components/UI/PageInput/CylinderDropdown";
import PeriodSelector from "../../../cylinder/components/history/PeriodSelector";
import { JOB_CARD_HISTORY } from "../../../../api/allApi_List";
import { formatDateString } from "../../../../functions/dateTime/formatDateString";
import CustomDateSelector from "./CustomDateSelector";
import { setError } from "../../../../redux/dataSlice";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";

const JobCardHistoryForm = ({
  setupData,
  getHistory,
  historyError,
  historyErrMsg,
}) => {
  const dispatch = useDispatch();
  const {
    register,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm();
  const { id, from, to, currentSelector } = watch();

  useEffect(() => {
    if (from && to && id) {
      getHistory(
        `${JOB_CARD_HISTORY}${id}/${formatDateString(from)}/${formatDateString(
          to,
        )}`,
      );
    }
  }, [id, from, to]);

  return (
    <form className="bg-white px-3 p-3 mt-3 rounded-lg border-1 border-dBlue-100">
      <div className="flex items-center gap-2">
        <div className="w-1/4">
          <CylinderDropdown
            label="Cylinder No.*"
            name={`id`}
            options={cylinderDetails(setupData)}
            setValue={setValue}
            control={control}
            error={errors.id}
          />
        </div>
        <PeriodSelector setValue={setValue} currentSelector={currentSelector} />
        {currentSelector === "custom" && (
          <CustomDateSelector
            from={from}
            to={to}
            register={register}
            setValue={setValue}
            errors={errors}
          />
        )}
      </div>
      {historyError && (
        <ErrorDisplay
          message={historyErrMsg}
          closeAction={() => dispatch(setError("false"))}
        />
      )}
    </form>
  );
};
export default JobCardHistoryForm;

export const cylinderDetails = (data) =>
  data.map((item) => {
    return {
      id: item.id,
      serialNumber: item.serialNumber,
      size: item.size,
      isFilled: item.currentState?.isFilled,
    };
  });
